import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import chevron from '../../../assets/images/icons/arrow-down.svg';

export const useStyles = makeStyles(({ palette, fontFamilies }: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '1rem',
    appearance: 'none',
    background: `no-repeat url(${chevron}) center right`,
    backgroundSize: 'contain',
    border: 'none',
    textTransform: 'uppercase',
    fontFamily: fontFamilies.primary,
    fontSize: '1rem',
    fontWeight: 400,
    '&:focus': {
      outline: `1px dotted ${palette.primary.dark}`,
    },
  },
}));
